// 商户优惠券管理路由配置
export const merchantPromotionalCoupons = {
  path: '/main/merchant-promotional-coupons',
  name: '商户优惠券管理',
  component: () => import('@/page/commons/routeTemp.vue'),
  children: [
    {
      path: 'index',
      name: '商户优惠券管理首页',
      component: () => import('@/page/merchant-promotional-coupons/index.vue'),
      meta: {
        requireAuth: true,
        title: '商户优惠券管理'
      }
    },
    {
      path: 'merchant-management',
      name: '商家管理',
      component: () => import('@/page/merchant-promotional-coupons/merchant-management.vue'),
      meta: {
        requireAuth: true,
        title: '商家管理'
      }
    },
    {
      path: 'coupon-rules',
      name: '领取规则',
      component: () => import('@/page/merchant-promotional-coupons/coupon-rules.vue'),
      meta: {
        requireAuth: true,
        title: '领取规则'
      }
    },
    {
      path: 'coupon-list',
      name: '优惠券',
      component: () => import('@/page/merchant-promotional-coupons/coupon-list.vue'),
      meta: {
        requireAuth: true,
        title: '优惠券'
      }
    },
    {
      path: 'coupon-detail/:id',
      name: 'coupon-detail',
      component: () => import('@/page/merchant-promotional-coupons/coupon-detail.vue'),
      meta: {
        requireAuth: true,
        title: '优惠券详情'
      }
    },
    {
      path: 'receive-record',
      name: '领取记录',
      component: () => import('@/page/merchant-promotional-coupons/receive-record.vue'),
      meta: {
        requireAuth: true,
        title: '领取记录'
      }
    },
    {
      path: 'verification-record',
      name: '核销记录',
      component: () => import('@/page/merchant-promotional-coupons/verification-record.vue'),
      meta: {
        requireAuth: true,
        title: '核销记录'
      }
    }
  ]
};
